<section class="mainTopBanner">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="topBannerWrapper align-items-center">
                    <div class="top-banner-left">
                        <h1>事例紹介</h1>
                        <h2>Trinkaの事例紹介</h2>
                        <p>Trinka（トリンカ）が世界の教育機関、出版社、組織・団体によるアカデミック・ライティングの執筆から発表までの行程をどのようにお手伝いしてきたか、事例の一部をご紹介します。</p>
                    </div>
                    <div class="top-banner-right">
                        <img src="assets/images/eposter.png" alt="eposter">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd section-purple">
    <div class="container">
        <div class="row match-box">
            <div class="col-md-6 dflex">
                <a [routerLink]="['/case-study/nit']" routerLinkActive="active" class="newsSection">
                    <div class="row align-items-center">
                        <div class="col-md-12">
                            <div class="newsBody">
                                <div class="caseImg">
                                    <img src="assets/images/case-study/nit-case-study.jpg" loading="lazy" decoding="async" alt="nit" class="img-fluid" />
                                </div>
                                <div class="section-title">
                                    <h2>日本工業大学 様<br/>学術英語執筆スキル向上のためTrinkaを導入
                                    </h2>
                                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                    <p>日本工業大学（NIT）は110年以上の長い歴史を持つ工学系の大学であり、日本で最も古くからある技術教育機関のひとつです。工学・建築を専門とする本校には、約4,000名の学生が在籍しています。</p>
                                    <div class="btn-group mt-4">
                                        <button type="button" class="filled-btn">もっと詳しく知る</button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-md-6 dflex">
                <a [routerLink]="['/case-study/tnq']" routerLinkActive="active" class="newsSection">
                    <div class="row align-items-center">
                        <!-- <div class="col-md-12">
                            <div class="accomplishSections_img">
                                <img src="../../../../assets/images/news/2024/crimson-best-place.png" class="img-fluid" alt="Interactive Awarded" />
                            </div>
                        </div> -->
                        <div class="col-md-12">
                            <div class="newsBody">
                                <div class="caseImg">
                                    <img src="assets/images/case-study/tnq-case-study.jpg" loading="lazy" decoding="async" alt="tnq" class="img-fluid" />
                                </div>
                                <div class="section-title">
                                    <h2>TNQ Tech Pvt. Ltd. 様<br/>世界最大級の学術出版社への技術提供にTrinkaを活用
                                    </h2>
                                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                    <p>STM（科学・技術・医学）出版社にとって、非の打ちどころのない言語品質を確保することは絶対条件です。言語校正プロセスは極めて重要であり、効率性を高めるために絶えず進化し続けなければなりません。</p>
                                    <div class="btn-group mt-4">
                                        <button type="button" class="filled-btn">もっと詳しく知る</button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>